var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          staticStyle: { "margin-top": "100px" },
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            "auto-complete": "on",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("登录")]),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "username" } },
            [
              _c("span", { staticClass: "svg-container" }),
              _c("el-input", {
                attrs: {
                  name: "username",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on",
                  placeholder: "请输入账户",
                },
                model: {
                  value: _vm.loginForm.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "username", $$v)
                  },
                  expression: "loginForm.username",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c("span", { staticClass: "svg-container" }),
              _c("el-input", {
                attrs: {
                  type: _vm.passwordType,
                  name: "password",
                  "auto-complete": "on",
                  tabindex: "2",
                  "show-password": "",
                  placeholder: "请输入密码",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleLogin.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.loginForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "password", $$v)
                  },
                  expression: "loginForm.password",
                },
              }),
            ],
            1
          ),
          _c("Verify", {
            ref: "verify",
            attrs: {
              mode: "pop",
              captchaType: "blockPuzzle",
              imgSize: { width: "330px", height: "155px" },
            },
            on: { success: _vm.capctchaCheckSuccess },
          }),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%", "margin-bottom": "30px" },
              attrs: { loading: _vm.loading, type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
            },
            [_vm._v("登录")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "copyright1" }, [
        _vm._v("Copyright © 2024 福州巨莱昂科技有限公司 版权所有 "),
      ]),
      _vm._m(0),
      _vm._m(1),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "copyright2" }, [
      _vm._v("julaiang.com"),
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn/#/Integrated/index" } },
        [_vm._v("闽ICP备2023003531-2号")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "copyright3" }, [
      _vm._v("julaiang.cn"),
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn/#/Integrated/index" } },
        [_vm._v("闽ICP备2023003531-1号")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }